(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["unasuave-video-player"] && !Shopify.designMode) return;
  try {
    (() => {
    const watched = new WeakSet();
    const loadPoster = (video) => {
      if (!video.dataset.patamorPoster) return;
      video.poster = video.dataset.patamorPoster;
      delete video.dataset.patamorPoster;
    };
    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadPoster(entry.target);
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '300px 0px' })
      : null;
    const initialize = (root = document) => {
      root.querySelectorAll('video[data-patamor-poster]').forEach((video) => {
        if (watched.has(video)) return;
        watched.add(video);
        if (observer) observer.observe(video);
        else loadPoster(video);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-player"] && !Shopify.designMode) return;
  try {
    (() => {
    const watched = new WeakSet();
    const loadPoster = (video) => {
      if (!video.dataset.patamorPoster) return;
      video.poster = video.dataset.patamorPoster;
      delete video.dataset.patamorPoster;
    };
    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadPoster(entry.target);
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '300px 0px' })
      : null;
    const initialize = (root = document) => {
      root.querySelectorAll('video[data-patamor-poster]').forEach((video) => {
        if (watched.has(video)) return;
        watched.add(video);
        if (observer) observer.observe(video);
        else loadPoster(video);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
